import { confirmDialog } from './confirm';

// Geeft een close-handler die — als er niet-opgeslagen wijzigingen zijn —
// eerst om bevestiging vraagt (FB-stijl). Anders sluit het venster direct.
// `dirty`: boolean of () => boolean. `onClose`: sluitfunctie. `t`: vertaalfunctie (optioneel).
export function makeDirtyClose(dirty, onClose, t) {
  return async () => {
    let isDirty = false;
    try { isDirty = typeof dirty === 'function' ? dirty() : !!dirty; } catch { isDirty = false; }
    if (!isDirty) { onClose(); return; }
    const tr = t || ((nl) => nl);
    const ok = await confirmDialog(
      tr('Je hebt nog niet-opgeslagen wijzigingen. Weet je zeker dat je dit venster wilt verlaten?',
         'Je hebt nog niet-opgeslagen wijzigingen. Weet je zeker dat je dit venster wilt verlaten?'),
      {
        confirmText: tr('Scherm verlaten', 'Scherm verlaten'),
        cancelText: tr('Doorgaan met invoeren', 'Doorgaan met invoeren'),
        danger: true,
      }
    );
    if (ok) onClose();
  };
}
